module.exports = __webpack_public_path__ + "img/three-karte.c115eb4.svg";